import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakePrecosVariacaoDiariaTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": "N/A",
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "VNPUPAR": 0,
            "VNAPUPAR": 0,
            "AtualizacaoMonetariaIncrementoPUPAR": 0,
            "JurosAcruadosPUPAR": 0,
            "JurosIncrementoPUPAR": 0,
            "VNPUMTM": 0,
            "VNAPUMTM": 0,
            "ValorFuturoAnteriorPUMTM": 0,
            "ValorFuturoAtualPUMTM": 0,
            "DeltaValorFuturoLimpoPUMTM": 0,
            "AtualizacaoMonetariaIncrementoPUMTM": 0,
            "JurosAcruadosPUMTM": 0,
            "JurosIncrementoPUMTM": 0,
            "TaxaRiskFreeAnterior": 0,
            "TaxaRiskFreeAtual": 0,
            "DeltaRiskFree": 0,
            "AjusteRiskFree": 0,
            "SpreadCreditoAnterior": 0,
            "SpreadCreditoAtual": 0,
            "DeltaSpreadCredito": 0,
            "AjusteSpreadCredito": 0,
            "AjusteMTMDiario": 0,
            "DataEvento": dayjs().format(DATE_FORMAT),
            "AmortizacaoOrdinariaPUPAR": 0,
            "AmortizacaoExtraordinariaPUPAR": 0,
            "JurosPUPAR": 0,
            "IncorporacaoJurosPUPAR": 0,
            "PremioPUPAR": 0,
            "PagamentoPUPAR": 0,
            "DataEventoProximo": dayjs().format(DATE_FORMAT),
            "ClassificacaoProximoEvento": "N/A",
            "ValorProximoEvento": 0,
            "PUPARAnterior": 0,
            "PUPARAtual": 0,
            "DeltaPUPAR": 0,
            "VarPUPAR": 0,
            "PU_MTMAnterior": 0,
            "PU_MTMAtual": 0,
            "DeltaPU_MTM": 0,
            "VarPUMTM": 0,
            "JustificativaPUPAR": "N/A",
            "JustificativaPUMTM": "N/A"
        }

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CETIP, DataReferencia, VNPUPAR, VNAPUPAR, AtualizacaoMonetariaIncrementoPUPAR, JurosAcruadosPUPAR, JurosIncrementoPUPAR,
            VNPUMTM, VNAPUMTM, ValorFuturoAnteriorPUMTM, ValorFuturoAtualPUMTM, DeltaValorFuturoLimpoPUMTM, AtualizacaoMonetariaIncrementoPUMTM, 
            JurosAcruadosPUMTM, JurosIncrementoPUMTM, TaxaRiskFreeAnterior, TaxaRiskFreeAtual, DeltaRiskFree, AjusteRiskFree, SpreadCreditoAnterior, 
            SpreadCreditoAtual, DeltaSpreadCredito, AjusteSpreadCredito, AjusteMTMDiario, DataEvento, AmortizacaoOrdinariaPUPAR, 
            AmortizacaoExtraordinariaPUPAR, JurosPUPAR, IncorporacaoJurosPUPAR, PremioPUPAR, PagamentoPUPAR, DataEventoProximo,
            ClassificacaoProximoEvento, ValorProximoEvento, PUPARAnterior, PUPARAtual, DeltaPUPAR, VarPUPAR, PU_MTMAnterior,
            PU_MTMAtual, DeltaPU_MTM, VarPUMTM, JustificativaPUPAR, JustificativaPUMTM
        } = newRow

        const body = {
            "CETIP": CETIP,
            "DataReferencia": DataReferencia,
            "VNPUPAR": VNPUPAR,
            "VNAPUPAR": VNAPUPAR,
            "AtualizacaoMonetariaIncrementoPUPAR": AtualizacaoMonetariaIncrementoPUPAR,
            "JurosAcruadosPUPAR": JurosAcruadosPUPAR,
            "JurosIncrementoPUPAR": JurosIncrementoPUPAR,
            "VNPUMTM": VNPUMTM,
            "VNAPUMTM": VNAPUMTM,
            "ValorFuturoAnteriorPUMTM": ValorFuturoAnteriorPUMTM,
            "ValorFuturoAtualPUMTM": ValorFuturoAtualPUMTM,
            "DeltaValorFuturoLimpoPUMTM": DeltaValorFuturoLimpoPUMTM,
            "AtualizacaoMonetariaIncrementoPUMTM": AtualizacaoMonetariaIncrementoPUMTM,
            "JurosAcruadosPUMTM": JurosAcruadosPUMTM,
            "JurosIncrementoPUMTM": JurosIncrementoPUMTM,
            "TaxaRiskFreeAnterior": TaxaRiskFreeAnterior,
            "TaxaRiskFreeAtual": TaxaRiskFreeAtual,
            "DeltaRiskFree": DeltaRiskFree,
            "AjusteRiskFree": AjusteRiskFree,
            "SpreadCreditoAnterior": SpreadCreditoAnterior,
            "SpreadCreditoAtual": SpreadCreditoAtual,
            "DeltaSpreadCredito": DeltaSpreadCredito,
            "AjusteSpreadCredito": AjusteSpreadCredito,
            "AjusteMTMDiario": AjusteMTMDiario,
            "DataEvento": DataEvento,
            "AmortizacaoOrdinariaPUPAR": AmortizacaoOrdinariaPUPAR,
            "AmortizacaoExtraordinariaPUPAR": AmortizacaoExtraordinariaPUPAR,
            "JurosPUPAR": JurosPUPAR,
            "IncorporacaoJurosPUPAR": IncorporacaoJurosPUPAR,
            "PremioPUPAR": PremioPUPAR,
            "PagamentoPUPAR": PagamentoPUPAR,
            "DataEventoProximo": DataEventoProximo,
            "ClassificacaoProximoEvento": ClassificacaoProximoEvento,
            "ValorProximoEvento": ValorProximoEvento,
            "PUPARAnterior": PUPARAnterior,
            "PUPARAtual": PUPARAtual,
            "DeltaPUPAR": DeltaPUPAR,
            "VarPUPAR": VarPUPAR,
            "PU_MTMAnterior": PU_MTMAnterior,
            "PU_MTMAtual": PU_MTMAtual,
            "DeltaPU_MTM": DeltaPU_MTM,
            "VarPUMTM": VarPUMTM,
            "JustificativaPUPAR": JustificativaPUPAR,
            "JustificativaPUMTM": JustificativaPUMTM
        }
        

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                } 
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'VNPUPAR',
            headerName: 'VNPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'VNAPUPAR',
            headerName: 'VNAPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AtualizacaoMonetariaIncrementoPUPAR',
            headerName: 'AtualizacaoMonetariaIncrementoPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JurosAcruadosPUPAR',
            headerName: 'JurosAcruadosPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JurosIncrementoPUPAR',
            headerName: 'JurosIncrementoPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'VNPUMTM',
            headerName: 'VNPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'VNAPUMTM',
            headerName: 'VNAPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'ValorFuturoAnteriorPUMTM',
            headerName: 'ValorFuturoAnteriorPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'ValorFuturoAtualPUMTM',
            headerName: 'ValorFuturoAtualPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DeltaValorFuturoLimpoPUMTM',
            headerName: 'DeltaValorFuturoLimpoPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AtualizacaoMonetariaIncrementoPUMTM',
            headerName: 'AtualizacaoMonetariaIncrementoPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JurosAcruadosPUMTM',
            headerName: 'JurosAcruadosPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JurosIncrementoPUMTM',
            headerName: 'JurosIncrementoPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'TaxaRiskFreeAnterior',
            headerName: 'TaxaRiskFreeAnterior',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'TaxaRiskFreeAtual',
            headerName: 'TaxaRiskFreeAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DeltaRiskFree',
            headerName: 'DeltaRiskFree',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AjusteRiskFree',
            headerName: 'AjusteRiskFree',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'SpreadCreditoAnterior',
            headerName: 'SpreadCreditoAnterior',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'SpreadCreditoAtual',
            headerName: 'SpreadCreditoAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DeltaSpreadCredito',
            headerName: 'DeltaSpreadCredito',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AjusteSpreadCredito',
            headerName: 'AjusteSpreadCredito',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AjusteMTMDiario',
            headerName: 'AjusteMTMDiario',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DataEvento',
            headerName: 'DataEvento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                } 
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'AmortizacaoOrdinariaPUPAR',
            headerName: 'AmortizacaoOrdinariaPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'AmortizacaoExtraordinariaPUPAR',
            headerName: 'AmortizacaoExtraordinariaPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JurosPUPAR',
            headerName: 'JurosPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'IncorporacaoJurosPUPAR',
            headerName: 'IncorporacaoJurosPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PremioPUPAR',
            headerName: 'PremioPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PagamentoPUPAR',
            headerName: 'PagamentoPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DataEventoProximo',
            headerName: 'DataEventoProximo',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                } 
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'ClassificacaoProximoEvento',
            headerName: 'ClassificacaoProximoEvento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            editable: true
        },
        {
            field: 'ValorProximoEvento',
            headerName: 'ValorProximoEvento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PUPARAnterior',
            headerName: 'PUPARAnterior',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PUPARAtual',
            headerName: 'PUPARAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DeltaPUPAR',
            headerName: 'DeltaPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'VarPUPAR',
            headerName: 'VarPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PU_MTMAnterior',
            headerName: 'PU_MTMAnterior',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PU_MTMAtual',
            headerName: 'PU_MTMAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DeltaPU_MTM',
            headerName: 'DeltaPU_MTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'VarPUMTM',
            headerName: 'VarPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'JustificativaPUPAR',
            headerName: 'JustificativaPUPAR',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            editable: true
        },
        {
            field: 'JustificativaPUMTM',
            headerName: 'JustificativaPUMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakePrecosVariacaoDiariaTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakePrecosVariacaoDiariaTable